import * as webStorage from '@com.rakuten.esd/myr-web-storage';
import { connect } from 'react-redux';
import { IReduxRootState } from '../../app/reduxRootState.interface';
import SideBar from './SideBar';
import { TextHelpers } from '../../utils/textHelpers';

export function mapStateToProps(state: IReduxRootState) {
    const ready = Boolean(state.app && state.app.clientConfig);
    const stateQueryParam = webStorage.getState();
    let returnUrl = '';
    let returnUrlText = '';
    let returnUrlEnabled = state.app.clientConfig.returnUrlEnabled ?? false;
    const currentLanguage = state.app.locale;
    const hasEKYC = state.member.hasEKYC ?? false;
    const hasSocialLink = state.member.hasSocialLink ?? false;
    const { myDataUrl } = state.app.clientConfig;
    const targetUrl = TextHelpers.replaceMyDataLang(myDataUrl ?? '', currentLanguage);
    const isShowMyData = state.app.presentationConfig.showSections.mydata;
    const isShowSignOut = state.app.presentationConfig.showSections.signout ?? true;
    let callbackUrl = '';

    if (ready) {
        if (state.app.clientConfig.returnUrl) {
            returnUrl = `${state.app.clientConfig.returnUrl}${
                stateQueryParam ? `?state=${stateQueryParam}` : ''
            }`;
            returnUrlText = state.app.clientConfig.returnUrlText
                ? state.app.clientConfig.returnUrlText
                : returnUrl.replace(/(^http(s)?:\/\/)|(\?.*$)/g, '');
        }
        callbackUrl = state.app.appConfig.CALLBACK_URL;
    }

    return {
        callbackUrl,
        hasEKYC,
        hasSocialLink,
        isShowMyData,
        isShowSignOut,
        ready,
        targetUrl,
        returnUrl,
        returnUrlText,
        returnUrlEnabled,
    };
}

const SideBarContainer = connect(mapStateToProps)(SideBar);

export default SideBarContainer;
